import React, { useEffect, Fragment } from 'react';
import { Route, Redirect } from 'react-router-dom';
import IdleTimer from 'react-idle-timer';
import { Observer } from 'mobx-react';

import { useRootStore } from '../../stores/BridgeProvider';
import storageService from '../../services/storage.service';
import Nav from './Nav';
import Spinner from '../../components/util/Spinner';
import permissionCheck from '../../components/util/PermCheck';
import { useSnackBars } from '../../alerts/SnackBarProvider';
import { COLORS } from '../../components/util/Colors';

const AuthRoute = ({
  component: PassedComponent,
  permission,
  children,
  ...rest
}) => {
  return (
    <Observer
      render={() => {
        const { authStore, orgStore } = useRootStore();
        const { settings } = orgStore;
        const { isAuthenticated, logout } = authStore;
        const permitted = permissionCheck(permission);
        const activeOrg = storageService.getItem('activeOrg');
        const handleAlert = useSnackBars();

        useEffect(() => {
          if (!settings && isAuthenticated) {
            orgStore.retrieveConfig();
          }
        }, [isAuthenticated]);

        return (
          <Route
            {...rest}
            render={props => {
              if (!isAuthenticated)
                return (
                  <Redirect
                    to={{ pathname: '/login', state: { from: props.location } }}
                  />
                );
              if (!activeOrg) return <Redirect to="/select-organization" />;
              // TODO: uncomment Ricky changes
              // if (!activeOrg || (!settings && state === 'done')) {
              //   console.log('PROBLEM', activeOrg, settings, state);
              //   return <Redirect to="/select-organization" />;
              // }
              if (!settings) return <Spinner />;
              if (!permitted && settings)
                return (
                  <Fragment>
                    <Redirect
                      to={{
                        pathname: '/dashboard',
                        state: { from: props.location },
                      }}
                    />
                    {handleAlert(
                      'You are not allowed access to that page',
                      COLORS.orange,
                    )}
                  </Fragment>
                );
              return (
                <Fragment>
                  <IdleTimer onIdle={logout} timeout={1000 * 60 * 30} />
                  <Nav {...props} />
                  {PassedComponent && <PassedComponent {...props} />}
                  {children}
                </Fragment>
              );
            }}
          />
        );
      }}
    />
  );
};

export default AuthRoute;
